import React from "react";

import { Box, Grid, Typography } from "@mui/material";
import { DataGridComponent } from "../../components/common/DataGridComponent";
import useEnrollmentColumns from "../../components/Enrollments/useEnrollmentColumns";
import { useEnrollmentDetails } from "../../components/Enrollments/useEnrollmentDetails";

import { useNavigate } from "react-router-dom";

const Enrollments: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();
  const columns = useEnrollmentColumns();
  const { rowData } = useEnrollmentDetails();

  const actions = {
    id: (data: any) => {
      navigate(`/enrollment/${data?.id}`);
    },
    studyID: (data: any) => {
      //console.debug(data)
    },
    siteID: (data: any) => {
      //console.debug(data)
    },
    actionsColumn: {
      action_edit: (data: any) => {
        // console.debug(data);
      },
      action_delete: (data: any) => {
        //console.debug(data)
      },
    },
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Enrollment
          </Typography>
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", height: "calc(100vh - 150px)" }}>
        <DataGridComponent
          columns={columns as any}
          hasDefinedColumns={false}
          actions={actions}
          rows={rowData}
          showQuickFilter
        />
      </Box>
    </>
  );
};

export default Enrollments;
